<template>
    <div v-show="isOpen" class="fixed z-50 px-4 pt-16 flex items-start justify-center inset-0 sm:pt-24">
        <transition
            enter-active-class="transition ease-linear duration-200"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition ease-linear duration-150"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div class="fixed inset-0 transition-opacity" @click="isOpen = false">
                <div class="absolute inset-0 bg-gray-900 opacity-50"></div>
            </div>
        </transition>

        <transition
            enter-active-class="transition ease-linear duration-200 transform"
            enter-from-class="opacity-0 scale-95"
            enter-to-class="opacity-100  scale-100"
            leave-active-class="transition ease-in ease-linear duration-150 transform"
            leave-from-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-95"
        >
            <div class="relative bg-gray-900 rounded-lg overflow-hidden shadow-xl transition-all max-w-lg w-full">
                <label for="globalSearchInput" class="sr-only">Search</label>
                <input
                    v-model="search"
                    ref="globalSearchInput"
                    @keydown.enter="go"
                    @keyup.down="selectDown"
                    @keyup.up="selectUp"
                    autocomplete="off"
                    id="globalSearchInput"
                    type="text"
                    style="caret-color: #6b7280"
                    class="appearance-none w-full bg-transparent px-6 py-4 text-gray-300 text-lg placeholder-gray-500 focus:outline-none"
                    :placeholder="$t('messages.search_students')"
                />
                <div class="border-t border-gray-800" v-show="users.length > 0">
                    <ul ref="results" style="max-height: 265px" class="overflow-y-auto">
                        <li v-for="(user, i) in users" :key="user.id">
                            <a
                                :href="user.url"
                                class="block px-6 py-3"
                                :class="{
                                    'bg-gray-700': selected === i,
                                    'hover:bg-gray-800': selected !== i,
                                }"
                            >
                                <span class="flex items-center">
                                    <img :src="user.avatar_or_default" alt="" class="shrink-0 h-6 w-6 rounded-full" />
                                    <span
                                        class="ml-3 block truncate"
                                        :class="{
                                            'text-gray-300': selected !== i,
                                            'text-white': selected === i,
                                        }"
                                    >
                                        {{ user.name }}
                                    </span>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
    </div>
</template>

<script setup>
import { nextTick, onBeforeMount, onMounted, ref, watch } from 'vue';
import { useGlobalSearch } from '@/composables/globalSearch.js';

const { isOpen, users, search, selected, searchUsers, selectUp, selectDown, go, onEscape } = useGlobalSearch();

watch(selected, (selectedIndex) => {
    scrollIntoView(selectedIndex);
});

const globalSearchInput = ref(null);

watch(
    isOpen,
    (value) => {
        if (value) {
            nextTick(() => globalSearchInput.value.focus());
        }
    },
    { immediate: true },
);

watch(search, (searchValue) => {
    if (searchValue.length <= 2) {
        users.value = [];
    } else {
        searchUsers(searchValue);
    }
});

const results = ref(null);

const scrollIntoView = (selectedIndex) => {
    nextTick(() => {
        if (users.value.length) {
            results.value.children[selectedIndex].scrollIntoView({
                block: 'nearest',
            });
        }
    });
};

onMounted(() => {
    document.addEventListener('keydown', onEscape);
});
onBeforeMount(() => {
    document.removeEventListener('keydown', onEscape);
});
</script>
